
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1975"}},[_c('path',{attrs:{"data-name":"Rectangle 2703","fill":"none","d":"M0 0h24v24H0z"}}),_c('path',{attrs:{"data-name":"Path 1303","d":"M23.168 7.445L12.832.554a1.626 1.626 0 00-1.664 0L.832 7.445A2.1 2.1 0 000 9l.005 14a1 1 0 001 1h21.99a1 1 0 001-1L24 9a2.1 2.1 0 00-.832-1.555zM21.995 22H2.005v-5.92h6.019l-2.293 2.293a1 1 0 101.414 1.414l4-4a1 1 0 000-1.414l-4-4a1 1 0 10-1.414 1.414l2.293 2.293h-6.02V9.09a.311.311 0 01.017-.031l9.983-6.656 9.984 6.656.016.031z","fill":"#adadad"}})])])
          )
        }
      }
    